import React, { Component } from "react";
// import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import About from "../about/About";

import "react-slideshow-image/dist/styles.css";

export class Home extends Component {
  static propTypes = {};

  render() {
    const gallry = {
      dots: false,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      speed: 500,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    };
    //................ This is a ROOM slider responsive ..................//

    const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 500,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    };
    // .............. This is a styles for rooms ..................//

    //............... This is a  Room item Arry ..................//
    const roomsItems = [
      {
        url: "assets/dulex.jpeg",
        name: "Dulex Room",
        price: "2100 /-",
        lists: ["TV", "Ac", "Wifi", "Breakfast"],
      },
      {
        url: "assets/pre.jpeg",
        name: "Premium Room",
        price: "2400 /-",
        lists: ["TV", "Ac", "Wifi", "Breakfast"],
      },
      {
        url: "assets/ex.jpeg",
        name: "Executive Room",
        price: "2700 /-",
        lists: ["TV", "Ac", "Wifi", "Breakfast"],
      },
      {
        url: "assets/suit_room.jpg",
        name: "Dulex Suite Room",
        price: "3200 /-",
        lists: ["TV", "Ac", "Wifi", "Breakfast"],
      },
    ];

    return (
      <div>
        {/* This is Banner Section  */}

        <section
          id="carouselExampleFade"
          className="carousel slide carousel-fade banner"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleFade"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleFade"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleFade"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleFade"
              data-bs-slide-to="3"
              aria-label="Slide 4"
            ></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="assets/about.JPG" className=" w-100" alt="..." />
              <div className="carousel-caption">
                <h6>
                  Enjoy Your Wonderful Holidays With A Great Luxury Experience!
                </h6>
                <h1 className="animated bounceInTop">
                  Welcome to Hotel Palash Residency
                </h1>
                <Link href="">Contact Now</Link>
              </div>
            </div>
            <div className="carousel-item">
              <img src="assets/event.JPG" className=" w-100" alt="..." />
              <div className="carousel-caption">
                <h1>
                  the best business hotel in
                  <br /> Ranchi's business center
                </h1>
                <Link href="">Contact Now</Link>
              </div>
            </div>
            <div className="carousel-item">
              <img src="assets/about.JPG" className=" w-100" alt="..." />
              <div className="carousel-caption">
                <h1>
                  Book the perfect accomodations <br />
                  without breaking the bank
                </h1>
                <Link href="">contact Now</Link>
              </div>
            </div>
            <div className="carousel-item">
              <img
                src="https://www.bmgrandhotelandresort.com/images/banner/4.jpg"
                className=" w-100"
                alt="..."
              />
              <div className="carousel-caption">
                <h1>Lets go to discovering</h1>
                <Link href="">Contact Now</Link>
              </div>
            </div>
          </div>
        </section>

        {/* This is  a About Section */}

        <About />

        {/* Thus is a Rooms Section */}
        <section className="rooms" id="rooms">
          <div className="container">
            <div className="heading">
              <h1>Featured Rooms</h1>
              <p>
                Explore the magnificent offerings from our wide range of
                luxurious and advanced feature-packed rooms.
              </p>
            </div>

            <Slider {...settings} className="slider">
              {roomsItems.map((items) => {
                return (
                  <div className="items">
                    <div className="item">
                      <img src={items.url} alt="" />
                      <div className="rooms-info">
                        <div className="head-info">
                          <h3>{items.name}</h3>
                          <h2>{items.price}</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
            <div className="wrap"></div>
          </div>
        </section>

        {/* This is a  Service Section */}

        <section className="service" id="service">
          <div className="container">
            <div className="heading">
              <h6>Our Service</h6>
              <h1>Explore Our Hotel Services</h1>
            </div>
          </div>
          <div className="service-items">
            <div className="images">
              <img src="assets/about.JPG" alt="" />
            </div>
            <div className="service-info">
              <h1>Features</h1>
              <p>
                Boutique Hotel located in the heart of Ranchi and with all 5
                star services
              </p>
              <div className="list">
                <ul>
                  <li>
                    <i className="fa fa-check"></i>Wifi
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Ac
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Bar
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Restaurent
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Travel Agency
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Business Center
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Checkin 12:00 PM
                  </li>
                  <li>
                    <i className="fa fa-check"></i>CheckOut 11:00 Am
                  </li>
                </ul>
                <ul>
                  <li>
                    <i className="fa fa-check"></i>Laundry Service
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Car Parking
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Lift
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Doctor On Call
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Cradit Card Facility
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Pick up drop facilities
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Early checkin 1000 /-
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Late checkout 1000 /-
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* This is a hero-booking Section */}

        <section className="hero-booking">
          <div className="container">
            <div className="cont">
              <div className="l-cont">
                <h5>FIND BEST HOTEL FOR LEAVING</h5>
                <h1>
                  Find the Best Hotel in <br />
                  Your Next Vacation
                </h1>
              </div>
              <Link to="booking">Contact Now</Link>
            </div>
          </div>
        </section>

        {/* This is a gallary Section */}

        <section className="popular" id="gllary">
          <h1>
            <i className="fa fa-instagram"></i> Gallery
          </h1>
          <div className="insta-img">
            <Slider {...gallry} className="slider">
              {GllaryItems.map((items) => {
                return (
                  <div>
                    <div className="product-box">
                      <img src={items.url} alt="" />
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>

          <div className="clearfix"></div>
        </section>
      </div>
    );
  }
}
// This is arry Of gallary
const GllaryItems = [
  {
    url: "assets/bar.JPG",
  },
  {
    url: "assets/family.JPG",
  },
  {
    url: "assets/pre.jpeg",
  },
  {
    url: "assets/out.JPG",
  },
  {
    url: "assets/reception.JPG",
  },
  {
    url: "assets/rooms.JPG",
  },
  {
    url: "assets/room_1.JPG",
  },
  {
    url: "assets/wating_room.JPG",
  },
  {
    url: "assets/even.JPG",
  },
  {
    url: "assets/wting_2.JPG",
  },
  {
    url: "assets/ex.jpeg",
  },
  {
    url: "assets/pre.jpeg",
  },
  {
    url: "assets/room_1.JPG",
  },
  {
    url: "assets/pre.jpeg",
  },
  {
    url: "assets/room_1.JPG",
  },
];

export default Home;
